export const generateSlug = (title) => {
  if (!title) return '';
  return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
};

export const getProblemUrl = (problem) => {
  if (!problem) return '/problems';
  
  // ✅ FIX: Prefer slug, fallback to generated slug from title, then _id
  if (problem.slug) {
    return `/problems/${problem.slug}`;
  }
  
  if (problem.title) {
    const generatedSlug = generateSlug(problem.title);
    if (generatedSlug) {
      return `/problems/${generatedSlug}`;
    }
  }
  
  // Last resort: use _id
  if (problem._id) {
    return `/problems/${problem._id}`;
  }
  
  return '/problems';
};

export const extractProblemIdentifier = (url) => {
  const match = url.match(/\/problems\/([^/]+)/);
  return match ? match[1] : null;
};
